import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\"><defs><style></style></defs><path d=\"M853.333 483.556H540.444v-312.89c0-15.928-12.515-28.444-28.444-28.444s-28.444 12.516-28.444 28.445v312.889h-312.89c-15.928 0-28.444 12.515-28.444 28.444s12.516 28.444 28.445 28.444h312.889v312.89c0 15.928 12.515 28.444 28.444 28.444s28.444-12.516 28.444-28.445V540.444h312.89c15.928 0 28.444-12.515 28.444-28.444s-12.516-28.444-28.445-28.444z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol